
import {Component, Prop, Vue} from "vue-property-decorator";
import {categoryDto} from "@/api/goods";

@Component({
  components: {}
})
export default class TreeSelect extends Vue {
  @Prop({
    default: () => {
      return []
    }
  }) readonly columns!: Array<categoryDto> // Tree选择数据
  @Prop({default: () => false}) isEdit!: boolean;
  @Prop({default: () => []}) typeDtlList?: Array<{ goodsType: string }> //修改初始值
  @Prop({default: () => '1'}) defaultLevelType?: string //是否是全选

  private selectColumns: Array<{ goodsType: string }> = [] // 已选分类层级
  private selectStr = '' // 已选分类层级名称
  private levelType = '1' // 全部选中传参  1为全部选中 全部选中时:selectColumns传[]  2:为部分选中
  private isCheckAll = false // 是否全选

  created() {
    if (this.isEdit) {
      this.levelType = this.defaultLevelType
      if (this.defaultLevelType === '1') {
        this.isCheckAll = true
        this.defaultChildrenSelect(this.columns)
      }
      this.typeDtlList.map(item => {
        this.handleDefaultSelect(this.columns, item.goodsType)
      })
    }
  }

// 递归判断添加 编辑时的回选功能
  handleDefaultSelect(columns: Array<categoryDto>, goodsType) {
    columns.map(item => {
      if (item.categoryId === goodsType) {
        item.isSelect = true
        if (item.children) {
          this.defaultChildrenSelect(item.children)
        }
      } else if (item.children) {
        this.handleDefaultSelect(item.children, goodsType)
      }
    })
  }

  defaultChildrenSelect(columns: Array<categoryDto>) { // 父级选中时,选中子集
    columns.map(item => {
      item.isSelect = true
      if (item.children) {
        this.defaultChildrenSelect(item.children)
      }
    })
  }


  toggle(record) {
    record.isSelect = !record.isSelect
    if (record.categoryLevel === '1') { // 一级菜单点击
      if (record.children) {
        record.children.map(i => {
          i.isSelect = record.isSelect
          if (i.children) {
            i.children.map(ii => {
              ii.isSelect = record.isSelect
            })
          }
        })
      }

    } else if (record.categoryLevel === '2') {// 二级菜单点击
      if (record.children) {
        record.children.map(i => {
          i.isSelect = record.isSelect
        })
      }
      this.checkIsOneAllSelect(record) // 控制父级是否改选中
    } else {
      this.checkIsTowAllSelect(record) // 控制父级是否改选中
    }
    this.isAllCheck()
    this.$forceUpdate()
  }

  isAllCheck() {
    let flag = true // 是否全选
    this.columns.map(i => {
      if (!i.isSelect) {
        flag = false
        return
      }
    })
    this.isCheckAll = flag
  }


  // 选中下级时,判断第一级是否选中
  checkIsOneAllSelect(record) {
    let parent: categoryDto = {}
    let flag = true // 最后一个子类被选中
    this.columns.map(item => {
      if (record.parentId === item.categoryId) {
        parent = item
      }
    })
    if (parent.children && parent.children.length > 0) {
      parent.children.map(item => {
        if (!item.isSelect) {
          flag = false
        }
      })
    }
    parent.isSelect = flag
    return flag
  }

  // 选中下级时,判断第二级是否选中
  checkIsTowAllSelect(record) {
    let flag = true // 最后一个子类被选中
    let parent: categoryDto = {}
    this.columns.map(i => {
      if (i.children) {
        i.children.map(ii => {
          if (record.parentId === ii.categoryId) {
            parent = {...ii}
          }
        })
      }
    })
    if (parent.children && parent.children.length > 0) {
      parent.children.map(item => {
        if (!item.isSelect) {
          flag = false
        }
      })
    }
    parent.isSelect = flag

    this.checkIsOneAllSelect(parent)
    return flag
  }

  handleCheckAll() {
    this.isCheckAll = !this.isCheckAll
    // 遍历
    this.columns.map(i => {
      i.isSelect = this.isCheckAll
      if (i.children) {
        i.children.map(ii => {
          ii.isSelect = this.isCheckAll
          if (ii.children) {
            ii.children.map(iii => {
              iii.isSelect = this.isCheckAll
            })
          }
        })
      }
    })
    if (!this.isCheckAll) {
      this.selectColumns = []
    }
    this.$forceUpdate()
  }

  handleOk() {
    if (this.isCheckAll) {
      // 如果是全选的
      this.levelType = '1'
      this.selectColumns = []
      this.selectStr = '全部商品'
    } else {
      this.levelType = '2'
      // 递归判断添加 选中的值得ID
      this.handlePushSelect(this.columns)
      this.selectStr = '自定义'
      // this.selectStr=this.selectStr.slice(0,this.selectStr.length-1)
    }
    console.log(this.selectColumns)
    console.log(this.levelType)
    if (this.selectColumns.length === 0 && this.levelType === '2') {
      this.selectStr = ''
    }
    this.$emit('confirm', this.selectColumns, this.selectStr, this.levelType)
  }

// 递归判断添加 选中的值得ID
  handlePushSelect(columns: Array<categoryDto>) {
    columns.map((item, index) => {
      if (item.isSelect) {
        this.selectColumns.push({goodsType: item.categoryId})
        // this.selectStr += item.categoryName + ','
      } else if (item.children) {
        this.handlePushSelect(item.children)
      }
    })
  }
}
